import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { PuzzlePieceIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { MEDIDENT_EXTENSION_XPI_URL } from '../../utils/medidentExtension';

export default function MedidentExtensionModal({ isOpen, onClose, onDismiss, onInstall }) {
  const { t } = useTranslation('common');

  const handleInstall = () => {
    onInstall?.();
    onClose();
    window.location.assign(MEDIDENT_EXTENSION_XPI_URL);
  };

  const handleDismiss = () => {
    onDismiss?.();
    onClose();
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="flex items-start justify-between gap-3 mb-4">
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[rgb(224,234,254)]">
                      <PuzzlePieceIcon className="h-5 w-5 text-gray-700" aria-hidden="true" />
                    </div>
                    <Dialog.Title as="h3" className="text-lg font-medium text-gray-900">
                      {t('header.medidentExtension.title')}
                    </Dialog.Title>
                  </div>
                  <button
                    type="button"
                    onClick={onClose}
                    className="rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                    aria-label={t('header.medidentExtension.close')}
                  >
                    <XMarkIcon className="h-5 w-5" />
                  </button>
                </div>

                <p className="text-sm text-gray-600 mb-6">
                  {t('header.medidentExtension.description')}
                </p>

                <div className="flex items-center justify-between gap-3">
                  <button
                    type="button"
                    onClick={handleDismiss}
                    className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[rgb(197,214,248)] focus:ring-offset-2"
                  >
                    {t('header.medidentExtension.dontShowAgain')}
                  </button>
                  <button
                    type="button"
                    onClick={handleInstall}
                    className="rounded-lg bg-[rgb(141,212,209)] px-4 py-2 text-sm font-medium text-gray-900 hover:bg-[rgb(120,195,192)] focus:outline-none focus:ring-2 focus:ring-[rgb(141,212,209)] focus:ring-offset-2"
                  >
                    {t('header.medidentExtension.install')}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
